import FeatureActivitiesLinks from "components/feature-links/feature-linked-activities";
import "components/feature-links/feature-links.scss";
import FeatureSubimttalsLinks from "components/feature-links/feature-linked-submittals";
import FeatureMaterialsLinks from "components/feature-links/feature-linked-materials";

export function MaterialDetailLinks(props: {
  featureInstanceData: any;
  canEditLinkingPage: boolean;
}) {
  const { featureInstanceData, canEditLinkingPage } = props;

  return (
    <div
      className="h-[580px] overflow-auto feature-links-card"
      data-testid="submittal-detail-links-root"
    >
      <FeatureSubimttalsLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        data-testid="submittal-detail-links-submittals"
      />
      <FeatureMaterialsLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        isRevisionMode={false}
        isVoidSubmittal={false}
        isDeletedSubmittal={false}
        isTrackedSubmittal={!!featureInstanceData?.is_tracked}
      />
      <FeatureActivitiesLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        isVoidSubmittal={false}
        isDeletedSubmittal={false}
        isTrackedSubmittal={!!featureInstanceData?.is_tracked}
        data-testid="submittal-detail-links-activities"
      />
    </div>
  );
}
